import { Design, PrintArea, PrintType } from '@/types';
import { ensureSizeMm } from '@/model/configuration/convertSize';
import { getMaxScale } from '@/model/configuration/getMaxScale';
import { isEnlargeable } from '@/model/printType/isEnlargeable';
import { isPixelDesign } from './isDesignType';

export const getScaleForPrintType = (
  design: Design,
  printArea: PrintArea,
  printType: PrintType,
  desiredScale: number
) => {
  let scale = Math.min(
    desiredScale,
    getMaxScale(
      ensureSizeMm(design.size, printType),
      0,
      printArea,
      printType,
      isPixelDesign(design),
      true
    )
  );

  if (isEnlargeable(printType)) {
    // vector print type means there is only a lower bound (only vector designs are possible)
    scale = Math.max(scale, design.restrictions.minimumScale / 100);
  }

  return scale;
};
